@if (isLoading()) {
  <div class="loading-container">
    <oui-loading></oui-loading>
  </div>
} @else {
  <div class="demande-pj__controls">
    <oui-button
      class="demande-pj__controls__back-btn"
      type="icon"
      color="secondary"
      (click)="setDisplayDemandePjPanel.emit()"
      ><oui-icon>arrow_back</oui-icon></oui-button
    >

    <oui-button
      class="demande-pj__controls__close-btn"
      type="icon"
      color="secondary"
      (click)="close.emit()"
      ><oui-icon>close</oui-icon></oui-button
    >
  </div>

  <div class="demande-pj__email">
    <span class="headline-6"
      >Demander des documents à {{ consultantName() }} {{ consultantLastname() }}</span
    >
  </div>

  <div class="demande-pj__disp-com-container">
    <div class="demande-pj__disp-com-header">
      <span style="font-weight: 500">Objet: Demande de documents</span>
      <oui-button
        class="demande-pj__controls__disp-com"
        type="text"
        color="secondary"
        (click)="displayComment.set(!displayComment())">
        <span class="demande-pj__controls__disp-com-color">{{
          !displayComment() ? 'Personnaliser' : 'Fermer'
        }}</span>
      </oui-button>
    </div>
    <oui-textarea
      class="demande-pj__commentaire"
      label="Commentaire"
      [style.display]="displayComment() ? 'unset' : 'none'"
      [hidden]="displayComment()"
      [resizeEnabled]="true"
      [rows]="5"
      [control]="commentControl"
      [errors]="commentErrors"></oui-textarea>
  </div>

  @if (selection.selected.length > 0) {
    <div class="filters__chips">
      <oui-chip-list type="selection">
        @for (docType of selection.selected; track $index) {
          <oui-chip (remove)="removeFilter(docType)">{{ docLabel[docType] }}</oui-chip>
        }
      </oui-chip-list>

      <a class="body-2" (click)="deleteAllFilters()">Effacer les filtres</a>
    </div>
  }

  <div class="demande-pj__doc">
    @for (option of docOptions; track $index) {
      <div class="demande-pj__docInfos">
        <span style="font-size: large">{{ option.label }}</span>
        <div class="demande-pj__docType">
          @for (child of option.children; track $index) {
            <oui-checkbox
              id="checkbox-{{ $index }}"
              [label]="child.label"
              (checkedChange)="selection.toggle(child.value!)"
              [checked]="selection.isSelected(child.value!)"></oui-checkbox>
          }
        </div>
      </div>
    }
  </div>

  <div class="demande-pj__footer">
    <oui-button
      class="actions__btn-send"
      [disabled]="
        selection.selected.length === 0 ||
        !commentControl.value ||
        commentControl.value === ''
      "
      (click)="onClickSendDemande()"
      >Envoyer la demande</oui-button
    >
  </div>
}
